import { Autocomplete, Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../app/hooks";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import isEmpty from "../../../common/helpers/isEmpty";
import { fetchWorkTitles } from "../../workTitles/workTitleSlice";
import { isFulfilled } from "@reduxjs/toolkit";
import { WorkTitle } from "../../orders/orderAPI";
import { useState } from "react";
import i18n from "i18next";

const RequiredInformation = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  const [availableWorkTitles, setAvailableWorkTitles] = useState<WorkTitle[]>(
    [],
  );
  const dispatch = useAppDispatch();

  const getWorkTitles = () => {
    if (isEmpty(availableWorkTitles)) {
      const language = i18n.language.substring(0, 2);
      dispatch(fetchWorkTitles({ language })).then((action) => {
        if (isFulfilled(action)) {
          setAvailableWorkTitles(action.payload);
        }
      });
    }
  };

  return (
    <FormSection title={t("customers:orderTemplate:requiredInformation")}>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography color="textSecondary">
          {t("customers:orderTemplate:orderTemplateName")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          control={control}
          name="name"
          rules={{ required: true }}
          render={({ field }) => (
            <CommonTextField
              {...field}
              sx={{ maxWidth: "372px" }}
              fullWidth
              error={!!errors.name}
            />
          )}
        />
      </Grid>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography color="textSecondary">{t("common:workTitle")}</Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          control={control}
          name="workTitle"
          rules={{
            required: true,
            validate: (value) => !!value?.id,
          }}
          render={({ field: { value, onChange } }) => (
            <Autocomplete
              value={value}
              onOpen={getWorkTitles}
              options={availableWorkTitles}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.name}
                </li>
              )}
              onChange={(_, newValue) => onChange(newValue)}
              renderInput={(params) => (
                <CommonTextField
                  {...params}
                  sx={{ maxWidth: "372px" }}
                  error={!!errors.workTitle}
                />
              )}
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};

export default RequiredInformation;
